<template>
  <div>
    <el-col :span="8" class="grid-img" v-for="(item,index) in myPhoneList" :key="index">
      <div @click="showImage(item)">
        <div class="grid_img_out pos_rel">
          <img :src="item.photoList.length>0 ? item.photoList[0].imgPath : '/static/images/phone.jpeg'" alt="">
          <div class="pos_abs grid-icon-area">
            <span class="iconfont icon-fabu" @click.stop="editPhoto(item,'edit')">编辑</span>
            <span class="iconfont icon-shanchu2" @click.stop="editPhoto(item,'del')">删除</span>
          </div>
          <div class="" style="position: relative;">
            <span class="tip_content">{{item.status == 0 ? '不公开' : '公开'}}</span>
          </div>
        </div>
        <div class="grid_content">
          {{item.title}}
        </div>
      </div>
    </el-col>
  </div>
</template>

<script>
export default {
  props: ['myPhoneList'],
  data () {
    return {}
  },
  methods: {
    showImage (item) {
      this.$router.push({
        name: 'showImageInfor',
        query: {
          code: item.code
        }
      })
    },
    editPhoto (item, state) {
      item.state = state
      this.$emit('showState', item)
    }
  },
  created () {
    // console.log(this.from,"图片详情")
  },
  mounted () {
    console.log(this.myPhoneList, "新数据")
  }
}
</script>

<!--css样式-->
<style lang="scss" scoped>
@import '../../../src/scss/commonH5.scss';
@import '../../scss/demo.scss';
.grid-img-area {
  position: relative;
}
.grid-icon-area {
  position: absolute;
  top: 14px;
  right: 10px;
  span {
    font-size: 16px;
    padding: 6px;
    border-radius: 50px;
    margin: 0 5px;
    color: #fff;
  }
  .icon-fabu {
    background: #1cafaf;
  }
  .icon-shanchu2 {
    background: #f60;
  }
}
/*相册区域*/
.grid-img {
  width: 30%;
  border-radius: 5px;
  box-shadow: 2px 4px 8px 4px rgba(197, 197, 197, 0.3);
  margin: 0px 30px 20px 0px;
  padding: 15px 14px;
}
.grid_content {
  padding-top: 8px;
  font-size: 14px;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  cursor: pointer;
}
.grid_img_out {
  height: 176px;
  img {
    width: 100%;
    height: 176px;
  }
}
.grid-img:nth-child(3n + 0) {
  margin-right: 0px;
}
.tip_content {
  position: absolute;
  color: #fff;
  padding: 2px 8px;
  background: rgba(244, 183, 38, 0.8);
  right: 0px;
  bottom: 5px;
  border-top-left-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/homeCommon/photo.vue